import '../styles/notifications.scss'

$('#constela__notificationcenter').remove()
$(() => $('<div id="constela__notificationcenter"><div></div></div>').insertAfter('#main'))

const notify = (notification: JQuery<HTMLElement>, blocking?: boolean): void => {
  if (blocking) {
    $('#constela__notificationcenter').addClass('blocked')
    notification.addClass('blocking')
  }
  $('#constela__notificationcenter > div').append(notification)
  setTimeout(() => notification.addClass('visible'), 100)
}

const dismiss = (notification: JQuery<HTMLElement>): void => {
  if (notification.hasClass('blocking')) {
    $('#constela__notificationcenter').toggleClass(
      'blocked',
      !!($('#constela__notificationcenter').find('.blocking').length - 1)
    )
  }
  notification.removeClass('visible').animate({ 'margin-bottom': -(notification.outerHeight() || 0) }, 400)
  setTimeout(() => {
    notification.remove()
    $('#constela__notificationcenter').toggleClass(
      'blocked',
      !!$('#constela__notificationcenter').find('.blocking').length
    )
  }, 400)
}

const filter = (string: string): string => (string + '').replace(/</g, '&lt;')

export const showAlert = (
  title: string,
  subline?: string,
  confirm?: string,
  error?: boolean,
  blocking?: boolean
): void => {
  const notification = $(
    `<div class="constela__notification constela__notification--inline ${error ? 'constela__notification--error' : ''}">
      <div class="constela__notification__content">
        <h4>${filter(title)}</h4>
        ${subline ? `<p>${filter(subline)}</p>` : ''}
      </div>
      ${
        confirm
          ? `<div class="constela__notification__buttons">
          <button class="button button--solid js-dismiss ${error ? 'button--cta' : ''}">${filter(confirm)}</button>
        </div>`
          : ''
      }
    </div>`
  )

  notification.find('.js-dismiss').click(() => dismiss(notification))
  if (!confirm) {
    setTimeout(() => dismiss(notification), 3000)
  }

  return notify(notification, blocking)
}

export const showConfirm = (
  title: string,
  subline = '',
  buttons: string[] = ['Abbrechen', 'OK'],
  error?: boolean,
  blocking?: boolean
): Promise<string> =>
  new Promise((resolve, reject) => {
    const notification = $(
      `<div class="constela__notification ${error ? 'constela__notification--error' : ''}">
        <div class="constela__notification__content">
          <h4>${filter(title)}</h4>
          ${subline ? `<p>${filter(subline)}</p>` : ''}
        </div>
        <div class="constela__notification__buttons">
          ${buttons
            .map(
              (label, i) => `
                <button class="button button--solid ${
                  i === buttons.length - 1 ? (error ? 'button--cta' : 'button--solid') : 'button--sec'
                } js-dismiss">${filter(label)}</button>
              `
            )
            .join('')}
        </div>
      </div>`
    )

    notification
      .find('.js-dismiss')
      .on('click', function () {
        const label = $(this).text()
        dismiss(notification)

        if (label === buttons[0]) reject(label)
        else resolve(label)
      })
      .eq(buttons.length - 1)
      .trigger('focus')

    notify(notification, blocking)
  })
